<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:07:42
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-28 16:39:38
-->
<template>
  <div id="app">
    <!-- 路由出口 -->
    <a-config-provider :locale="zhCN">
    <router-view v-if="secretKey"/>
  </a-config-provider>
  </div>
</template>
<script>
  import zhCN from "ant-design-vue/es/locale/zh_CN";
  import {getAuth} from "@/api/common.js"
  import { removeWatermark, setWaterMark } from "./utils/waterMark";
  export default{
    data(){
      return {
        zhCN,
        secretKey: false,
      }
    },
    destroyed() {
    removeWatermark();
  },
    mounted(){
       const that = this;
       let name = JSON.parse(sessionStorage.getItem('userInfo'));
       if(name){
          setWaterMark("", name.name+name.phone.substring(name.phone.length-4));
       }
        getAuth().then((res)=>{
            if(res.code == 0){
                that.secretKey = true;
                localStorage.setItem('secret',res.data)
            }
        })
    }
  }
</script>
<style lang="less" scoped>
#app {
  height: 100%;
  overflow-y: hidden;
}

</style>
<style>
.ant-message{
    top:400px !important;
    z-index: 999999999;
  }
  .ant-select-dropdown{
  z-index: 10000;
}
.ant-table-fixed-left table, .ant-table-fixed-right table{
  filter: blur(0px);
}
</style>
